import React from 'react';

const CLIENT_COLORS = [
  '#3b82f6', // blue-500
  '#f59e0b', // amber-500
  '#10b981', // emerald-500
  '#8b5cf6', // violet-500
  '#f87171', // red-400
  '#ec4899', // pink-500
  '#06b6d4', // cyan-500
  '#f97316', // orange-500
];

export function getClientColor(index: number): string {
  return CLIENT_COLORS[index % CLIENT_COLORS.length];
}

/**
 * One colour per partner ROLE, the same on every case. Deep, low-saturation
 * tones so they can never be mistaken for a client colour above (all bright
 * 400/500s). Partner chips are also rounded rectangles, never pills, so the
 * difference doesn't rest on colour alone.
 */
export const PARTNER_ROLE_COLORS = {
  crematorium: '#475569', // slate-600
  dropoff: '#92400E', // amber-800 (brown)
  transport: '#115E59', // teal-800
} as const;

interface ClientFilterBarProps {
  clients: { id: number; name: string; color: string }[];
  activeClientIds: Set<number>;
  onToggle: (clientId: number) => void;
  showSystemEvents: boolean;
  onToggleSystem: () => void;
}

export function ClientFilterBar({ clients, activeClientIds, onToggle, showSystemEvents, onToggleSystem }: ClientFilterBarProps) {
  if (clients.length === 0) return null;

  return (
    <div className="flex items-center gap-2 px-3 sm:px-4 py-2 border-b shrink-0 overflow-x-auto">
      {clients.map((client) => {
        const isActive = activeClientIds.has(client.id);
        return (
          <button
            key={client.id}
            onClick={() => onToggle(client.id)}
            className="rounded-full px-3 py-1 text-xs font-medium transition-colors border shrink-0 whitespace-nowrap"
            style={
              isActive
                ? { backgroundColor: client.color, borderColor: client.color, color: '#fff' }
                : { backgroundColor: 'transparent', borderColor: client.color, color: client.color }
            }
          >
            {client.name}
          </button>
        );
      })}
      <button
        onClick={onToggleSystem}
        className="rounded-full px-3 py-1 text-xs font-medium transition-colors border"
        style={
          showSystemEvents
            ? { backgroundColor: '#6b7280', borderColor: '#6b7280', color: '#fff' }
            : { backgroundColor: 'transparent', borderColor: '#9ca3af', color: '#9ca3af' }
        }
      >
        System
      </button>
    </div>
  );
}
